import React from 'react';
import CheckButton from './CheckButton';
import Flex from './containers/Flex';
import PropTypes from 'prop-types';

export const checkButtonStyle = {
    fontFamily: 'roboto',
    display: 'flex',
    height: 34,
    fontSize: 14,
    fontWeight: 500,
    borderRadius: 5,
    justifyContent: 'left',
    border: 0,
    alignItems: 'center'
};

export const RadioCheckButton = ({
    id = 'radio-check-button',
    initialValue = false,
    value,
    onClick,
    buttonActiveStyle,
    buttonInactiveStyle,
    radioActiveStyle,
    radioInactiveStyle,
    radioCheckStyle,
    style,
    children,
    ...props
}) => {
    buttonActiveStyle = {
        ...checkButtonStyle,
        color: 'rgb(94,94,94)',
        backgroundColor: 'rgb(255,210,135)',
        ...style,
        ...buttonActiveStyle
    };
    buttonInactiveStyle = {
        ...checkButtonStyle,
        color: 'rgb(84,84,84)',
        backgroundColor: 'rgb(240,240,240)',
        ...style,
        ...buttonInactiveStyle
    };

    const radioStyle = {
        boxSizing: 'border-box',
        height: 16,
        width: 16,
        borderRadius: 8,
        alignContent: 'center',
        alignSelf: 'center',
        margin: 9.5,
        border: '1px solid rgb(151,151,151)',
        backgroundColor: 'rgb(255,255,255)',
        justifyContent: 'center',
        ...style
    };
    radioActiveStyle = {
        ...radioStyle,
        ...radioActiveStyle
    };
    radioInactiveStyle = {
        ...radioStyle,
        ...radioInactiveStyle
    };
    radioCheckStyle = {
        boxSizing: 'border-box',
        height: 6,
        width: 6,
        border: '2px solid rgb(253,154,0)',
        backgroundColor: 'rgb(250,168,0)',
        borderRadius: 3,
        alignSelf: 'center',
        ...style,
        ...radioCheckStyle
    };

    const RadioCheck = () => <div id={`${id}-check`} style={radioCheckStyle} />;

    return (
        <CheckButton
            {...props}
            id={id}
            value={value}
            initialValue={initialValue}
            onClick={onClick}
            activeStyle={buttonActiveStyle}
            inactiveStyle={buttonInactiveStyle}
        >
            <Flex style={value ? radioActiveStyle : radioInactiveStyle}>
                {value ? <RadioCheck /> : null}
            </Flex>
            {children}
        </CheckButton>
    );
};

RadioCheckButton.defaultProps = {
    id: 'radio-check-button',
    initialValue: false
};

RadioCheckButton.propTypes = {
    id: PropTypes.string,
    initialValue: PropTypes.bool,
    value: PropTypes.bool,
    onClick: PropTypes.func,
    buttonActiveStyle: PropTypes.object,
    buttonInactiveStyle: PropTypes.object,
    radioActiveStyle: PropTypes.object,
    radioInactiveStyle: PropTypes.object,
    radioCheckStyle: PropTypes.object,
    style: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};

export default RadioCheckButton;
